import $ from 'jquery';

class Settings {

    constructor() {
        $(document.body).on('change', '.gpay-button-option, #gpay-button-context', this.updateButton.bind(this));
        $(document.body).on('change', '.gpay-button-type', this.onButtonTypeChange.bind(this));
        this.init();
    }

    onButtonTypeChange(e) {
        const context = $(e.currentTarget).data('context');
        if (context) {
            $('#gpay-button-context').val(context);
        }
        this.updateButton();
    }

    init() {
        $('#gpay-button-context').val('checkout');
        this.paymentsClient = new google.payments.api.PaymentsClient({environment: 'TEST'});
        this.updateButton();
    }

    getButtonType() {
        const context = $('#gpay-button-context').val();
        if (context) {
            return $(`.gpay-button-type[data-context="${context}"]`).val() || 'buy';
        }
        return 'buy';
    }

    updateButton() {
        this.$button?.remove();
        this.$button = $(this.paymentsClient.createButton({
            onClick() {},
            buttonColor: $('.button-color').val(),
            buttonType: this.getButtonType(),
            buttonRadius: $('.button-radius').val(),
            buttonSizeMode: 'fill'
        }));
        this.$button.find('button').css({height: `${$('.button-height').val()}px`});
        $('#gpay-button').append(this.$button);
    }
}

new Settings();
